module.exports = __webpack_public_path__ + "img/qt-zxh@2x.8481d5e7.png";